//import ClipboardJS from "clipboard";

import { postJSON } from "./ajax";
import playerStore from "lib/player_store";

export default class Jango {
  constructor() {
    if (this.instance) {
      return this.instance;
    }

    this.instance = this;

    //    const c = this.constructor;
  }

  reNav(context) {
    postJSON({ url: "/facebook/login" }).then((data) => {
      // receive redirect from facebook controller
      playerStore.setLogInOpen(false);
      let m;
      switch (context) {
        case "signup":
          m = "Thanks for Signing Up!";
          break;

        case "connect":
          m = "Thanks for connecting with Facebook!";
          break;

        default:
          m = "You are Logged In!";
      }
      playerStore.setSnackCopy(m);
      playerStore.set_user_id(data.user_id);

      //  Turbolinks.visit(window.location.pathname);
    });
  }

  // hopefully depecated
  // set WEB_APP_VERSION for refreshing site on breaking deploy
  check_client_ver(app_version) {
    console.log("check client ver", app_version, window.ver);
    if (window.ver && app_version && app_version != window.ver) {
      console.log("top VERSION MISMATCH: window RELOAD");
      // document.location.assign(document.URL);
      return window.location.reload();
    }
  }

  // share_copy_clip() {
  //   try {
  //     if (typeof _jango.share_cb != "undefined" && _jango.share_cb) {
  //       _jango.share_cb.destroy();
  //     }
  //     _jango.share_cb = new ClipboardJS("#share_copy").on("success", function (
  //       e
  //     ) {
  //       //console.log(e)
  //       $(e.trigger).attr({
  //         tooltip: "Copied",
  //         "tooltip-position": "right",
  //       });
  //       setTimeout(function () {
  //         $(e.trigger).removeAttr("tooltip tooltip-position");
  //       }, 4000);
  //     });
  //   } catch (e) {}
  // }

  // more_videos(html_id, song_id, artist_id) {
  //   var params = {};
  //   params.cb = new Date().getTime();
  //   $.get(
  //     "/artists/" + artist_id + "/songs/" + song_id + "/more_videos",
  //     params,
  //     function (data) {
  //       $("#" + html_id).append(data);
  //     }
  //   );
  // }

  // music::band_show only
  // handle_on_page_fan(regged) {
  //   if (!regged) {
  //     if ($("#lo-comment")) {
  //       $("#lo-comment")
  //         .click(() => {
  //           _jangoSplash.popme();
  //         })
  //         .focus(() => {
  //           _jangoSplash.popme();
  //         });
  //     }
  //   }
  //   if ($("#bfemail")[0]) {
  //     $("#bfemail").on("keyup", function () {
  //       checkone($("#bfemail").val(), $("#bfemail"));
  //     });
  //   }
  //   var checkone = function (f, e) {
  //     if (/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i.test(f)) {
  //       if ($(e).css("color") == "rgb(0,102,0)") {
  //         $(e).animate(
  //           { border: "1px solid #000", color: "rgb(0,102,0)" },
  //           500
  //         );
  //       }
  //     } else {
  //       if ($(e).css("color") == "rgb(255,0,0)") {
  //         $(e).animate(
  //           { border: "1px solid #ff0000", color: "rgb(255,0,0)" },
  //           500
  //         );
  //       }
  //     }
  //   };
  // }

  //TODO remove
  replaceWithLoader() {}

  //async_assets only
  //  lazy_load_all() {
  //   $("img[data-original]").lazyload({ failure_limit: 20 });
  // }

  // force_lazy(target) {
  //   if (target) {
  //     $("#" + target + " img[data-original]")
  //       .lazyload({ failure_limit: 20 })
  //       .slice(0, 20)
  //       .trigger("appear");
  //   } else {
  //     $("img[data-original]")
  //       .lazyload({ failure_limit: 20 })
  //       .slice(0, 20)
  //       .trigger("appear");
  //   }
  // }
}
